(function () {
  if (customElements.get('cart-recommendations-carousel')) return;

  customElements.define(
    'cart-recommendations-carousel',
    class CartRecommendationsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.it-cart-recommendations__track');
        this.prevBtn = this.querySelector('.it-cart-recommendations__nav--prev');
        this.nextBtn = this.querySelector('.it-cart-recommendations__nav--next');

        if (!this.track) return;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
        }

        this.track.addEventListener('scroll', this.updateNavState.bind(this), { passive: true });
        window.addEventListener('resize', this.updateNavState.bind(this));

        // Run after layout settles so scrollWidth/clientWidth are accurate
        requestAnimationFrame(() => this.updateNavState());
      }

      scrollByCard(direction) {
        if (!this.track) return;
        const item = this.track.querySelector('.it-cart-recommendations__item');
        const gap = 12; // matches the 1.2rem gap in CSS at default font size
        const cardWidth = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
        this.track.scrollBy({ left: cardWidth * direction, behavior: 'smooth' });
      }

      updateNavState() {
        if (!this.track) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 0;
        if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll;
      }
    }
  );
})();

/* ---------- 2. Fix stale "is-empty" class on the outer <cart-drawer> ---------- */
(function () {
  function syncIsEmptyClass() {
    var drawer = document.querySelector('cart-drawer');
    var cartDrawerItems = document.querySelector('cart-drawer-items');
    if (!drawer || !cartDrawerItems) return;

    var actuallyEmpty = cartDrawerItems.classList.contains('is-empty');
    drawer.classList.toggle('is-empty', actuallyEmpty);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var cartDrawerEl = document.getElementById('CartDrawer');
    if (!cartDrawerEl || !window.MutationObserver) return;

    // renderContents() replaces #CartDrawer's innerHTML on every cart
    // update — watch for that and re-sync right after.
    var observer = new MutationObserver(function () {
      syncIsEmptyClass();
    });
    observer.observe(cartDrawerEl, { childList: true });

    // Also correct it once up front in case it's already wrong.
    syncIsEmptyClass();
  });
})();

/* ---------- 4. Third-party "fast checkout" overlay detection ----------
 * Shared by sections 3 and 5 below. Matches on id/class/iframe-src rather
 * than a single hardcoded selector, since third-party checkout widgets
 * (Shiprocket and similar) don't publish a stable markup contract and can
 * change their DOM between releases — a broad "does anything on the page
 * mention shiprocket / fast-checkout right now" check is more durable than
 * chasing their exact current class names.
 *
 * IMPORTANT: "matches the selector" is NOT enough on its own — Shiprocket
 * (and similar widgets) leave hidden elements (launcher buttons, tracking
 * iframes, etc.) sitting in the DOM on every page, including pages with no
 * overlay open at all. So every match is additionally required to be
 * VISIBLE before we treat it as "an overlay is actually showing."
 */
(function () {
  function isVisible(el) {
    if (!el || !el.isConnected) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity || '1') === 0) {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  // Being visible isn't enough on its own — Shiprocket (and similar) can
  // leave small, permanently-visible elements on the page (trust badges,
  // shipping-estimate widgets, tracking pixels) that ALSO match our
  // id/class selector but are NOT a fast-checkout modal. Only trust a
  // match if it's actually shaped like an overlay: a checkout iframe, or
  // a fixed/absolute/sticky element covering a meaningful chunk of the
  // viewport (the way a real modal does).
  function isLikelyOverlay(el) {
    if (!el) return false;
    if (el.tagName === 'IFRAME') return isVisible(el);
    if (!isVisible(el)) return false;
    var style = window.getComputedStyle(el);
    if (['fixed', 'absolute', 'sticky'].indexOf(style.position) === -1) return false;
    var rect = el.getBoundingClientRect();
    // Area-based, not width+height thresholds — a checkout panel can be a
    // narrow, full-height side drawer (like Shiprocket's Buy Now modal)
    // that would fail a "must be wide AND tall" test but still clearly
    // isn't a small badge/widget. Covering ~15%+ of the viewport area is
    // enough to tell the two apart.
    var elArea = rect.width * rect.height;
    var viewportArea = window.innerWidth * window.innerHeight;
    return viewportArea > 0 && elArea >= viewportArea * 0.15;
  }

  var OVERLAY_SELECTOR =
    'iframe[src*="shiprocket" i], [id*="shiprocket" i], [class*="shiprocket" i], ' +
    '[id*="srfc" i], [class*="srfc" i], [id*="fast-checkout" i], [class*="fast-checkout" i]';

  function isThirdPartyCheckoutNode(node) {
    if (!node || node.nodeType !== 1) return false;

    if (node.tagName === 'IFRAME' && /shiprocket/i.test(node.getAttribute('src') || '')) {
      return isLikelyOverlay(node);
    }

    var haystack =
      (node.id || '') + ' ' + (node.className && node.className.baseVal !== undefined ? '' : node.className || '');
    if (/shiprocket|srfc|fast-?checkout/i.test(haystack) && isLikelyOverlay(node)) {
      return true;
    }

    if (node.querySelector) {
      var match = node.querySelector(OVERLAY_SELECTOR);
      if (match && isLikelyOverlay(match)) return true;
    }

    return false;
  }

  function thirdPartyCheckoutOverlayActive() {
    var nodes = document.querySelectorAll(OVERLAY_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (isLikelyOverlay(nodes[i])) return true;
    }
    return false;
  }

  window.__itThirdPartyCheckout = {
    isNode: isThirdPartyCheckoutNode,
    isActive: thirdPartyCheckoutOverlayActive,
  };

  // Continuously watch for one of these overlays appearing (regardless of
  // what triggered it) and force our own drawer closed if so — this covers
  // the race where the overlay mounts a beat AFTER we've already opened.
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          // Newly-added nodes may not have finished rendering/layout yet,
          // so re-check visibility a beat later before acting.
          (function (node) {
            requestAnimationFrame(function () {
              if (isThirdPartyCheckoutNode(node)) {
                var drawer = document.querySelector('cart-drawer');
                if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') {
                  try {
                    drawer.close();
                  } catch (e) {
                    /* no-op */
                  }
                }
              }
            });
          })(added[j]);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();

/* ---------- 5. Flag "Buy Now" / fast-checkout clicks up front ----------
 * Shiprocket's "Buy Now" button calls the SAME /cart/add.js endpoint our
 * fetch-intercept in section 3 is watching, so from the network's point
 * of view a Buy Now click is indistinguishable from a real Add to Cart
 * click. Trying to tell them apart AFTER the request (by checking if a
 * checkout overlay appeared) is fragile — timing, sizing, DOM changes.
 *
 * Instead: listen for the click itself, in the capture phase, before any
 * request fires. If the clicked control looks like a "Buy Now" / dynamic
 * checkout button (by visible text or class/id), set a short-lived flag.
 * openCartDrawer() checks this flag and refuses to open — and consumes it
 * immediately so it doesn't accidentally suppress the NEXT, unrelated
 * add-to-cart.
 */
(function () {
  window.__itSkipNextCartOpen = false;
  var skipTimer = null;

  function looksLikeBuyNow(el) {
    if (!el) return false;
    var text = (el.textContent || '').trim().toLowerCase();
    if (/\bbuy( it)? now\b/.test(text)) return true;
    var attrs =
      (el.id || '') + ' ' + (el.className && el.className.baseVal !== undefined ? '' : el.className || '') + ' ' +
      (el.getAttribute && (el.getAttribute('name') || '') );
    return /shiprocket|srfc|fast-?checkout|buy-?now|dynamic-checkout|shopify-payment-button/i.test(attrs);
  }

  document.addEventListener(
    'click',
    function (e) {
      var el = e.target && e.target.closest ? e.target.closest('button, a, [role="button"], input[type="submit"]') : null;
      if (!el || !looksLikeBuyNow(el)) return;

      window.__itSkipNextCartOpen = true;
      if (skipTimer) clearTimeout(skipTimer);
      // Failsafe auto-clear in case the flag is never consumed (e.g. the
      // click didn't actually lead to a /cart/add call) so it can't get
      // permanently stuck suppressing future real add-to-cart clicks.
      skipTimer = setTimeout(function () {
        window.__itSkipNextCartOpen = false;
      }, 4000);
    },
    true // capture phase — runs before the button's own click handlers
  );
})();

/* ---------- 3. Auto-open cart drawer on add-to-cart ----------
 * This theme's pub/sub (subscribe/PUB_SUB_EVENTS) is module-scoped and not
 * exposed on window, so we can't hook into it from a plain script. Instead
 * we intercept the actual /cart/add network request directly — this works
 * regardless of how the theme's internal JS is structured.
 *
 * NOTE: a "Buy Now" style fast-checkout button (e.g. Shiprocket) also calls
 * /cart/add.js internally before opening its OWN checkout overlay. If we
 * opened our drawer in that case too, it ends up sitting behind the
 * third-party overlay looking like a second, broken, empty cart. So right
 * before opening — and only then — we check whether one of those overlays
 * is already VISIBLE on the page and skip if so (the MutationObserver in
 * section 4 also catches the case where it appears a moment later).
 *
 * TIMING FIX: we no longer open the drawer on a fixed setTimeout. Instead
 * we wait for #CartDrawer's content to actually change (the theme's own
 * AJAX re-render swapping in the new cart HTML) before calling
 * drawer.open() — so the drawer never shows stale/empty markup before the
 * real product content is in the DOM. A bounded fallback timer still fires
 * if no mutation is observed, so the drawer can't get stuck closed.
 */
(function () {
  function openCartDrawer() {
    if (window.__itSkipNextCartOpen) {
      window.__itSkipNextCartOpen = false; // consume — this was a Buy Now click, not a real add-to-cart
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.classList.contains('active')) return; // already open (e.g. theme's own flow got there first)
    if (typeof drawer.open !== 'function') return;
    if (window.__itThirdPartyCheckout && window.__itThirdPartyCheckout.isActive()) return; // e.g. Shiprocket overlay already visible
    try {
      drawer.open();
    } catch (e) {
      console.warn('[it-cart-drawer] drawer.open() threw an error:', e);
    }
  }

  // Waits for #CartDrawer's content to actually be replaced (indicating
  // the theme's AJAX cart re-render has landed) before opening — rather
  // than guessing with a fixed delay. Falls back to a bounded timeout if
  // no mutation shows up (e.g. this add-to-cart didn't actually change
  // markup, or the theme's own render already happened before this ran).
  function openCartDrawerWhenReady(maxWaitMs) {
    var cartDrawerEl = document.getElementById('CartDrawer');
    if (!cartDrawerEl || !window.MutationObserver) {
      setTimeout(openCartDrawer, 400); // no observer support — old behavior as last resort
      return;
    }

    var settled = false;

    var observer = new MutationObserver(function () {
      if (settled) return;
      settled = true;
      observer.disconnect();
      // One more frame so any nested re-render (e.g. recommendations
      // carousel swap) has a chance to settle before we reveal the drawer.
      requestAnimationFrame(openCartDrawer);
    });
    observer.observe(cartDrawerEl, { childList: true, subtree: false });

    setTimeout(function () {
      if (settled) return;
      settled = true;
      observer.disconnect();
      openCartDrawer();
    }, maxWaitMs);
  }

  if (window.fetch && !window.__itCartDrawerFetchPatched) {
    window.__itCartDrawerFetchPatched = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var method = (init && init.method) || (typeof input === 'object' && input && input.method) || 'GET';
      var isAddToCart =
        typeof url === 'string' && url.indexOf('/cart/add') !== -1 && String(method).toUpperCase() === 'POST';

      var result = nativeFetch.apply(this, arguments);

      if (isAddToCart) {
        result
          .then(function (response) {
            if (response && response.ok) {
              // Wait for the real re-render instead of a blind delay —
              // this is what fixes the "empty cart flash, then product
              // appears" behavior. 900ms cap is generous enough to cover
              // slow connections while still bounded.
              openCartDrawerWhenReady(900);
            }
            return response;
          })
          .catch(function () {
            /* don't let this break real add-to-cart error handling */
          });
      }

      return result;
    };
  }

  // Also try the pub/sub route in case a future theme update exposes it —
  // harmless no-op if it's never found.
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'cart-items') return;
      openCartDrawerWhenReady(700);
    });
  }
})();